import React from "react";
import { withRouter } from "react-router";
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { Button, Grid, Icon, Header, List, Accordion, Loader, Dimmer } from "semantic-ui-react";
import ActivityTree from './../../Drive/Tree/ActivityTree/ActivityTree'
import CreateInitiativeSteps from './Steps';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import CircularDependencies from '../../../../common/CircularDependencies';
import { debounce } from "lodash";

const Graph = require('graph.js/dist/graph.full.js');
let graph = new Graph();
let activityNodesMap = new Map();

const createGraph = function (activities, parent, isSequential) {
    try {
        if (activities && activities.length > 0) {

            for (const [index, activity] of activities.entries()) {

                const graphObject = {
                    duration: activity.duration,
                    name: activity.name,
                }
                graph.addVertex(activity._id.toString(), graphObject);

                if (parent) {
                    graph.addEdge(parent._id.toString(), activity._id.toString());
                }
                if (isSequential && (!activity.activities || (activity.activities && activity.activities.length === 0))) {
                    if (index !== 0 && parent.activities[index - 1].isLeafNode) {
                        graph.addEdge(activity._id.toString(), parent.activities[index - 1]._id.toString());
                    }
                }
                if (activity.dependencies && activity.dependencies.length > 0) {
                    for (const dependency of activity.dependencies) {
                        if (!graph.hasVertex(dependency.toString())) {

                            graph.ensureVertex(dependency.toString(), { details: "temp ref" });
                        }


                        graph.ensureEdge(activity._id.toString(), dependency.toString())
                    }
                }
                createGraph(activity.activities, activity, isSequential);
            }
        }
        else {
            return;
        }
    }
    catch (e) {
        console.error('Error while cerating the initiative graph ', e);
    }
}

const calculateDuration = function (pathData) {
    let totalDuration = 0;
    for (const pathEntry of pathData) {
        const vertexValue = graph.vertexValue(pathEntry);

        if (vertexValue) {

            if (vertexValue.duration) {
                totalDuration += vertexValue.duration
            }
        }
    }
    return totalDuration;
}

let pathMap = new Map();
const traverseGraph = function (nodeId, dataString) {
    let count = 0;
    for (let [from] of graph.verticesTo(nodeId)) {
        count++
        traverseGraph(from, `${dataString}-${from}`);
    }
    if (count === 0) {
        const pathParts = dataString.split("-");
        const leafNodeKey = pathParts[0];
        const existingPathData = pathMap.get(leafNodeKey);
        if (!existingPathData) {
            pathMap.set(leafNodeKey, pathParts);
        } else {
            if (calculateDuration(pathParts) > calculateDuration(existingPathData)) {
                pathMap.set(leafNodeKey, pathParts);
            }
        }
    }
}

const getActivityNodes = function (nodeId) {
    for (let [to] of graph.verticesFrom(nodeId)) {
        const toVertexValue = graph.vertexValue(to);
        if (toVertexValue.duration) {
            const activityObj = {
                id: to,
                name: toVertexValue.name,
                start: toVertexValue.startDate,
                end: toVertexValue.endDate,
                duration: toVertexValue.duration,
                isMilestone: toVertexValue.isMilestone,
                runStatus: toVertexValue.runStatus,
                calculatedStatus: toVertexValue.calculatedStatus,
                state: toVertexValue.state,
                progress: toVertexValue.progress,
                raci: toVertexValue.raci

            }
            activityNodesMap.set(to, activityObj);
        }
        getActivityNodes(to);
    }

}
class ConfigureActivity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cycles: null,
            dependencyArr: null,
            activeIndex: 1,
            leafActivityError: null,
        }
        this.parentRef = React.createRef();
    }


    async componentWillMount() {
        dispatch.app.setRouteParams(this.props.match.params)
        dispatch.initiatives.setTabName("configureActivity");
        let selectedDataById = this.props.selectedDataById;

        let objValidation = Object.entries(selectedDataById).length === 0 && selectedDataById.constructor === Object
        if (objValidation) {
            await dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        }
        if (selectedDataById.organizationId && selectedDataById.category) {
            dispatch.initiatives.getPublishedContentDataAsync({ organizationId: selectedDataById.organizationId, category: selectedDataById.category });
        }
        dispatch.initiatives.getTeamManagersData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, teamId: this.props.selectedDataById.teamId });
    }

    getDuration = () => {

        graph = new Graph();
        activityNodesMap = new Map();
        createGraph(this.props.selectedDataById.activities, null, this.props.selectedDataById.isSequential);

        pathMap = new Map();

        if (graph.cycle() && graph.cycle().length > 0) {
            this.props.selectedDataById.cycles = [];
            for (let cycle of graph.cycles()) {
                this.props.selectedDataById.cycles.push(cycle);
            }
        }
    }

    getMapping(id) {
        if (this.props.selectedDataById.activities) {
            for (let i = 0; i < this.props.selectedDataById.activities.length; i++) {
                let activity = this.props.selectedDataById.activities[i];
                if (id.toString() === activity._id.toString()) {
                    return activity.name;
                }
                if (activity.activities) {
                    for (let j = 0; j < activity.activities.length; j++) {
                        let subActivity = activity.activities[j];
                        if (id.toString() === subActivity._id.toString()) {
                            return activity.name + " > " + subActivity.name;
                        }
                        if (subActivity.activities) {
                            for (let k = 0; k < subActivity.activities.length; k++) {
                                let childActivity = subActivity.activities[k];
                                if (childActivity) {
                                    if (id.toString() === childActivity._id.toString()) {
                                        return activity.name + " > " + subActivity.name + " > " + childActivity.name;
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }

    }

    showdependentMilestoneError(actArr) {
        let counter = 0;
        this.setState({
            dependencyError: <div  >
                <div style={{ maxHeight: (this.props.componentDesignerDimension.windowHeight - this.props.componentDesignerDimension.height) - 310, overflow: "auto" }}>
                    {

                        this.props.selectedDataById.milestoneDependentActivity.map(act => {
                            return <List divided verticalAlign='middle' size="small" key={counter++} >{
                                <List.Item key={act._id}>
                                    <List.Content>
                                        <List.Header>{this.getMapping(act._id)}</List.Header>
                                    </List.Content>
                                </List.Item>
                            }</List>
                        })
                    }</div>
            </div>
        })
    }


    showLeafActivityError(actArr) {
        this.setState({
            leafActivityError: <div  >
                <div style={{ maxHeight: (this.props.componentDesignerDimension.windowHeight - this.props.componentDesignerDimension.height) - 310, overflow: "auto" }}>

                    {this.props.leafActivity.map(act => {
                        return <List divided verticalAlign='middle' size="small" className="w_100 display-block" key={act._id}>
                            <List.Item >
                                <List.Content>
                                    <List.Header>{this.getMapping(act._id)}</List.Header>
                                </List.Content>
                            </List.Item>
                        </List>
                    })
                    }

                </div>
            </div>
        })
    }
    checkDependency = (treeData, dependentActivityArr) => {
        treeData.forEach((treeNode) => {
            if (treeNode.isMilestone && treeNode.dependencies.length === 0) {
                dependentActivityArr.push(treeNode);
            }
            if (treeNode.activities) {
                this.checkDependency(treeNode.activities, dependentActivityArr);
            }
        });
    }
    checkDependentsForMilestoneActivities = () => {
        let dependentActivityArr = [];
        this.checkDependency(this.props.selectedDataById.activities, dependentActivityArr);
        this.props.selectedDataById.milestoneDependentActivity = dependentActivityArr;
    }



    async next() {

        this.setState({ loader: true })
        await this.CheckNextButton();
        delete this.props.selectedDataById.cycles;
        this.checkDependentsForMilestoneActivities();
        this.getDuration()

        setTimeout(() => {
            this.setState({ loader: false })
        }, 1000);

        if (this.props.leafActivity.length !== 0) {
            this.showLeafActivityError(this.props.leafActivity)
        }
        if (!this.props.selectedDataById.cycles && this.props.leafActivity.length === 0) {
            dispatch.app.setCollapsedResourcePaneIndexTemp(null)
            dispatch.initiatives.showResourecePane(null)
            dispatch.lifeCycle.disableLinking();
            dispatch.lifeCycle.setDependencyIcon(false);
            dispatch.initiatives.setSelectedActivityData({});
            this.setState({ cycles: null, leafActivity: null, milestoneDependentActivity: null })
            this.nextClick()
        }
    }

    nextClick = debounce(async () => {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/finalize/' + this.props.match.params.initiativeId
        });
        // history.push({
        //     pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/integration/' + this.props.match.params.initiativeId
        // });
    }, 1000)

    CheckNextButton() {
        let dependentActivityArr = [];
        let leafActivityArr = [];
        let isDurationSetAllActivities = true;
        const scanForActivitiesForDurationCheck = function (treeData) {
            treeData.forEach(function (treeNode) {
                if (treeNode.isLeafNode && (!treeNode.duration || treeNode.duration === 0) && !treeNode.isMilestone) {
                    isDurationSetAllActivities = false;
                }
                if (treeNode.isParentNode && treeNode.activities && treeNode.activities.length === 0) {
                    leafActivityArr.push(treeNode);
                }
                if (treeNode.activities) {
                    scanForActivitiesForDurationCheck(treeNode.activities);
                }

            });
        }

        scanForActivitiesForDurationCheck(this.props.selectedDataById["activities"]);
        dispatch.initiatives.isDurationSet(isDurationSetAllActivities);
        dispatch.initiatives.setDependetMilestoneAct(dependentActivityArr)
        dispatch.initiatives.setLeafAct(leafActivityArr)
    }

    backClick() {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/teamMapping/' + this.props.match.params.initiativeId
        });
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.initiatives.showResourecePane(null);
        dispatch.lifeCycle.disableLinking();
        dispatch.lifeCycle.setDependencyIcon(false);
        dispatch.initiatives.setSelectedActivityData({});
    }


    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }
    cancelEdit = () => {
        let message = <div className="confirmMessage">
            <h3>Cancel Editing</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you want to Cancel editing this initiative?</p>
            <span >All the changes done until now will be lost.</span>
        </div>
        toastr.confirm(message, {
            okText: 'Cancel Editing',
            cancelText: 'Keep Editing',
            onOk: () => {
                dispatch.initiatives.setTabName(null);
                dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                dispatch.initiatives.showResourecePane(null);
                dispatch.initiatives.cancelInitiativeEdit(this.props.selectedDataById);
            }
        });
    }
    render() {
        const { activeIndex } = this.state;
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;
        return (
            <div ref={this.parentRef} style={{ width: "100%", maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>
                <Grid className="containerBoxFullWidth">
                    <Grid.Row >
                        <BreadCrumbs {...this.props} />
                    </Grid.Row>
                    <Grid.Row >
                        <CreateInitiativeSteps {...this.props} setPage="configureActivity" />
                    </Grid.Row>
                    <Grid.Row >
                        <Grid className="w_100"  >

                            <Grid.Row className="configureActivity" >
                                <Grid.Column width={16}>
                                    <Header as='h4' >Configure Initiative Flow</Header>
                                </Grid.Column >
                                <Dimmer inverted active={this.props.copyActivityLoader}>
                                    <Loader size='massive'></Loader>
                                </Dimmer>
                                <Grid.Column width={this.props.selectedDataById.cycles || this.state.leafActivityError ? 9 : 16}>
                                    <div ref={this.parentRef} className="activities" >
                                        {this.props.selectedDataById && this.props.selectedDataById.activities ?
                                            <ActivityTree
                                                elements="activities"
                                                selectedPracticeLibrary={this.props.selectedDataById}
                                                user={this.props.user}
                                                getSelection={dispatch.initiatives.getSelectedActivityDetails}
                                                parent={this.props.selectedActivityData.parentCommunity}
                                                selectedActivityData={this.props.selectedActivityData}
                                                addAction={dispatch.initiatives.createActivity}
                                                deleteAction={dispatch.initiatives.deleteActivity}
                                                updateAction={dispatch.initiatives.updateActivity}
                                                changeIndexAction={dispatch.initiatives.changeActivityIndex}
                                                isAddActivityModalOpen={this.props.isAddActivityModalOpen}
                                                isAddPhaseModalOpen={this.props.isAddPhaseModalOpen}
                                                {...this.props}
                                            />
                                            : 'Loading...'}

                                    </div>
                                </Grid.Column >


                                {this.props.selectedDataById.cycles || this.state.leafActivityError ?
                                    <Grid.Column className="circularErrorList" width={7} style={{ width: "100%", maxHeight: designerHeight ? designerHeight - 240 : 280, overflowY: "scroll" }}>
                                        <Accordion>
                                            {this.props.selectedDataById.cycles ?
                                                <div>
                                                    <Accordion.Title active={activeIndex === 1} index={1} onClick={this.handleClick}>
                                                        <Icon name='dropdown' />
                                                        Circular dependencies issues
                                                    </Accordion.Title>
                                                    <Accordion.Content active={activeIndex === 1}>
                                                        <CircularDependencies selectedEntity={this.props.selectedDataById} showActions={true} fixAction={dispatch.initiatives.removeAllDependenciesFromInitiative} />
                                                    </Accordion.Content>
                                                </div> : ''}

                                            {this.state.leafActivityError ?
                                                <div>
                                                    <Accordion.Title active={activeIndex === 2} index={2} onClick={this.handleClick}>
                                                        <Icon name='dropdown' />
                                                        Following activities must have at least one leaf Activity.
                                                    </Accordion.Title>
                                                    <Accordion.Content active={activeIndex === 2}>
                                                        {this.state.leafActivityError && this.state.leafActivityError}
                                                    </Accordion.Content>
                                                </div> : ''}

                                        </Accordion>
                                    </Grid.Column> : ""}


                            </Grid.Row>
                            {this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 4 ?
                                <Grid.Row>
                                    <Grid.Column width={8} className="pad_0">
                                        <div className="bottom_button_set" >
                                            <Button
                                                disabled={this.props.buttonStatus}
                                                onClick={() => this.backClick()}
                                                type="button"
                                                className="button-cancel" >Previous </Button>
                                        </div>
                                    </Grid.Column >
                                    <Grid.Column width={8} className="pad_0">
                                        <div className="bottom_button_set" style={{ textAlign: "right" }} >
                                            {this.props.selectedDataById.status === 4 && <Button
                                                type="button"
                                                className="button-cancel"
                                                onClick={() => this.cancelEdit()}>Cancel </Button>}
                                            <Button
                                                disabled={!this.props.isDurationSet}
                                                loading={this.state.loader}
                                                type='submit'
                                                id='next'
                                                className="button-submit"
                                                onClick={() => this.next()} > Next </Button>
                                        </div>
                                    </Grid.Column >

                                </Grid.Row> : ""}

                        </Grid >
                    </Grid.Row>
                </Grid>

            </div>

        );
    }
}

export default withRouter(ConfigureActivity);